import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=d6c3e640&scoped=true&"
import script from "./profit.vue?vue&type=script&lang=js&"
export * from "./profit.vue?vue&type=script&lang=js&"
import style0 from "./profit.vue?vue&type=style&index=0&id=d6c3e640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c3e640",
  null
  
)

export default component.exports